/*
 * Copyright (c) 2022. AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { Enum } from "../../../types/types";

export const PasswordStrengthPageLocator = Enum("password__strength_meter", "password__label_strength");
